import HeaderBlog from "../components/HeaderBlog";
import TextoPadraoBlog from "../components/TextoPadraoBlog";
import TituloBlog from "../components/TituloBlog";
import TableBlog from "../components/TableBlog";
import Obs from "../components/Obs";
import ListaBlog from "../components/ListaBlog";
import Footer from "../components/Footer";

const QuantoOCriadorDeConteudoRealmentePagaDeImposto = () => {
    return (
        <>
            <HeaderBlog
                titulo="Quanto o criador de conteúdo realmente paga de imposto — e como pagar menos de forma legal"
                subtitulo="YouTuber, influenciador, streamer. Não importa o canal — se você está monetizando, o Leão já tem os olhos em você. A boa notícia é que existem formas legais de reduzir essa conta, e a ContBlack vai te mostrar como."
                data="21 de maio de 2025"
                tempoLeitura={8}
            />

            <TextoPadraoBlog
                texto={[
                    "Sabe aquela sensação de receber um pagamento do AdSense, de uma marca ou da Hotmart e não saber exatamente quanto daquilo é seu de verdade? Esse é o ponto de partida de 90% dos criadores que chegam até nós. E a resposta depende de uma única decisão: como você está estruturado.",
                ]}
            />

            <TituloBlog index={1} titulo="De onde vem o dinheiro do criador — e como cada fonte é tributada" />

            <TextoPadraoBlog
                texto={[
                    "Antes de falar em imposto, é preciso entender que a renda de um criador raramente vem de uma fonte só. Cada uma delas tem um tratamento fiscal diferente:",
                ]}
            />

            <TableBlog titulos={[]} conteudo={[
                {
                    situacao: "AdSense / YouTube",
                    valor: "Receita de plataforma estrangeira, paga em dólar",
                    extraOne: <b>Exige atenção</b>,
                },
                {
                    situacao: "Publis & Patrocínios",
                    valor: "MContratos com marcas, pagos por PIX ou transferência",
                    extraOne: <b>Tributável no CPF</b>,
                },
                {
                    situacao: "Infoprodutos",
                    valor: "Cursos, e-books, mentorias via Hotmart, Kiwify etc.",
                    extraOne: <b>Melhor como PJ</b>,
                },
                {
                    situacao: "Subs & Doações",
                    valor: "Twitch, Live Pix, Super Chat, memberships",
                    extraOne: <b>Tributável no CPF</b>,
                },
                {
                    situacao: "Links de Afiliado",
                    valor: "Comissões de plataformas nacionais e internacionais",
                    extraOne: <b>Melhor como PJ</b>,
                },
                {
                    situacao: "Licenciamento",
                    valor: "Uso de imagem, voz ou conteúdo por terceiros",
                    extraOne: <b>Depende do contrato</b>,
                }]}
            />

            <Obs texto="Receber sem declarar não é invisível. O Pix, os depósitos em conta e os pagamentos de plataformas internacionais deixam rastro. A Receita Federal cruza essas informações com bancos e com a própria Receita dos EUA (via acordos internacionais)." />

            <TituloBlog index={2} titulo="Na prática: o criador que recebe R$ 15 mil por mês como pessoa física" />

            <TextoPadraoBlog
                texto={[
                    "Vamos a um cenário real. Um criador que fatura R$ 15.000 por mês via CPF — sem CNPJ, sem planejamento — tem a seguinte situação:",
                ]}
            />

            <TableBlog titulos={["Simulação: R$ 15.000/mês como Pessoa Física (CPF)", "Detalhes"]} conteudo={[
                {
                    situacao: "Faturamento bruto mensal",
                    valor: "R$ 15.000",
                },
                {
                    situacao: "IRPF — Imposto de Renda",
                    valor: <span style={{ color: "red" }}>– R$ 3.750</span>,
                },
                {
                    situacao: "Carnê-Leão",
                    valor: <span style={{ color: "red" }}>Obrigatório</span>,
                },
                {
                    situacao: "INSS (opcional, mas recomendado)",
                    valor: <span style={{ color: "red" }}>– R$ 908</span>,
                },
                {
                    situacao: "O que sobra no bolso (estimativa)",
                    valor: "R$ 10.342",
                }]}
            />

            <TextoPadraoBlog
                texto={[
                    "Quase R$ 4.700 foram para impostos — e isso sem considerar multas por atraso no carnê-leão ou DARF. Agora veja o que muda com um CNPJ bem estruturado.",
                ]}
            />

            <TituloBlog index={3} titulo="O mesmo criador com CNPJ no Simples Nacional" />

            <TextoPadraoBlog
                texto={[
                    "Com uma Microempresa no Simples Nacional, o cenário muda significativamente. A tributação sai da lógica do imposto de renda progressivo e passa para uma alíquota sobre o faturamento — muito menor para a maioria das atividades de criadores:",
                ]}
            />

            <TableBlog titulos={["Simulação: R$ 15.000/mês como Pessoa Jurídica (CNPJ)", "Detalhes"]} conteudo={[
                {
                    situacao: "Faturamento bruto mensal",
                    valor: "R$ 15.000",
                },
                {
                    situacao: "DAS — Simples Nacional",
                    valor: <span style={{ color: "red" }}>– R$ 900</span>,
                },
                {
                    situacao: "Distribuição de lucro (pró-labore otimizado)",
                    valor: "Isento de IR",
                },
                {
                    situacao: "O que sobra no bolso (estimativa)",
                    valor: "R$ 14.100",
                }]}
            />

            <Obs texto="A diferença entre os dois cenários é de aproximadamente R$ 3.758 por mês — ou quase R$ 45 mil por ano que ficam no seu bolso, de forma totalmente legal." />

            <TituloBlog index={4} titulo="E os pagamentos internacionais? YouTube, Twitch e Patreon" />
            
            <TextoPadraoBlog
                texto={[
                    "Esse é o ponto que mais gera dúvida — e mais multa quando ignorado. Receber em dólar, euro ou qualquer moeda estrangeira tem regras específicas no Brasil:",
                ]}
            />

            <TableBlog titulos={["Fonte pagadora", "Detalhes", "Condições"]} conteudo={[
                {
                    situacao: "YouTube / AdSense",
                    valor: "Pagamento em dólar pelo Google. É renda do exterior — precisa ser declarada. Com CNPJ, o tratamento é mais favorável.",
                    extraOne: <b>Renda exterior</b>,
                },
                {
                    situacao: "Twitch",
                    valor: "Subs e bits pagos em dólar. Sem CNPJ, entra como renda pessoa física sujeita ao carnê-leão mensal.",
                    extraOne: <b>Carnê-leão s/ CNPJ</b>,

                },
                {
                    situacao: "Patreon / Buy Me a Coffee",
                    valor: "Receita recorrente de plataformas estrangeiras. Exige atenção redobrada na declaração anual.",
                    extraOne: <b>Renda exterior</b>,

                },
                {
                    situacao: "TikTok Creator Fund",
                    valor: "Pagamento via plataforma, com câmbio na conversão. O tratamento depende de como o dinheiro chega ao Brasil.",
                    extraOne: <b>Exige análise</b>,

                }]}
            />

            <Obs texto="O Brasil tem acordos de troca de informações com os EUA e a União Europeia. Isso significa que a Receita Federal pode saber quanto você recebeu do Google, Meta e Amazon antes mesmo de você declarar. Estar em dia não é opcional — é estratégico." />

            <TituloBlog index={5} titulo="Como pagar menos imposto de forma legal: 5 estratégias reais" />

            <ListaBlog itens={[
                <><b>Abra um CNPJ no regime certo para a sua atividade:</b> <br /> Não existe um único modelo para criadores. YouTuber, streamer, infoprodutor e influenciador têm perfis de faturamento diferentes — e o regime tributário ideal varia. Um contador especializado faz essa análise antes de abrir qualquer CNPJ.</>,
                <><b>Distribua lucro em vez de pagar salário alto para si mesmo:</b> <br /> Dentro de uma empresa no Simples Nacional, a distribuição de lucros é isenta de Imposto de Renda. Isso significa que você pode se remunerar com um pró-labore menor — pagando menos INSS e IR — e complementar com distribuição de dividendos sem tributação adicional.</>,
                <><b>Deduza as despesas reais do negócio:</b> <br /> Equipamento de gravação, iluminação, microfone, assinaturas de software, internet, espaço de trabalho — tudo isso pode ser deduzido como despesa da empresa. O que antes era gasto pessoal passa a reduzir a base de cálculo do imposto.</>,
                <><b>Planeje a conversão dos recebimentos internacionais:</b> <br /> O momento e a forma da conversão de moeda estrangeira impactam diretamente quanto você paga. Uma conta de pagamento internacional bem estruturada, combinada com o CNPJ certo, pode reduzir significativamente a tributação sobre receitas do exterior.</>,
                <><b>Fique em dia com o calendário fiscal — sem exceção:</b> <br /> Parece óbvio, mas é onde mais criadores perdem dinheiro. Atraso no DAS gera multa automática. Atraso na declaração anual gera multa. Regularidade fiscal não é só obrigação — é a diferença entre pagar o necessário e pagar o desnecessário.</>,
            ]} />

            <Obs texto="O imposto que você paga não é fixo. Ele é resultado de uma escolha — sua estrutura. Quem planeja paga menos. Quem ignora, paga mais. E ainda paga multa por cima." />
            
            <Footer />
        </>
    )
}

export default QuantoOCriadorDeConteudoRealmentePagaDeImposto;